export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative border-t border-[var(--ink)] bg-[var(--ink)] text-[var(--bg)] py-16 md:py-20"
      data-testid="site-footer"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Big sign-off */}
        <div className="font-sans-display text-[clamp(48px,9vw,140px)] leading-[0.9] tracking-[-0.04em] uppercase">
          Until
          <br />
          <span className="text-white" style={{ color: "#0851F2" }}>
            we speak.
          </span>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 border-t border-white/15 pt-10">
          <div className="md:col-span-5">
            <img
              src="/brand/emily-logo.png"
              alt="Emilly"
              className="h-16 md:h-20 w-auto select-none mb-4"
              draggable={false}
            />
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/60">
              Emilly Studio · UI/UX & Graphic Designer · Belgrade
            </div>
            <a
              href="mailto:emilly.nekovic04@gmail.com"
              className="mt-4 inline-block font-sans-display uppercase text-2xl md:text-3xl link-underline text-white break-words"
              data-testid="footer-email"
            >
              emilly.nekovic04@gmail.com
            </a>
          </div>

          <div className="md:col-span-7">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/60">
              Index
            </span>
            <ul className="mt-3 grid grid-cols-2 gap-y-1">
              {[
                { label: "UI/UX", id: "work" },
                { label: "Illustration", id: "illustrations" },
                { label: "Graphic", id: "graphic" },
                { label: "About", id: "about" },
                { label: "Contact", id: "contact" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() =>
                      document
                        .getElementById(l.id)
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="font-sans-display uppercase text-xl hover:text-[#0851F2] transition-colors"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col md:flex-row gap-3 justify-between font-mono text-[10px] uppercase tracking-[0.25em] text-white/60">
          <span>© {year} Emilly Studio · Belgrade, RS</span>
          <span>Made with bold love · {year}</span>
        </div>
      </div>
    </footer>
  );
}
